module.exports = __webpack_public_path__ + "media/images/about-us/Headshots/Jack Crowley-bff67053f3120868ab0df9db9de4d100.png";